import type { WriteDebugLogFn } from '@wix/cli-debug-log';
import { pathExists, readJson, writeJson } from '@wix/cli-fs';
import {
  getAstroAppConfigPath,
  astroAppConfigSchema,
} from '@wix/cli-astro-definitions';
import type { AstroAppConfig } from '@wix/cli-astro-definitions';

export async function readAppConfig(
  projectFolder: string,
  writeDebugLog?: WriteDebugLogFn
) {
  const configPath = getAstroAppConfigPath(projectFolder);
  const isConfigExist = await pathExists(configPath);

  if (!isConfigExist) {
    return null;
  }

  try {
    const json = await readJson(configPath);
    const appConfig = await astroAppConfigSchema.safeParseAsync(json);

    if (!appConfig.success) {
      return null;
    }

    return appConfig.data;
  } catch (e) {
    writeDebugLog?.(e);
    return null;
  }
}

export async function saveAppConfig(
  projectFolder: string,
  config: AstroAppConfig
) {
  const currentConfig = (await readAppConfig(projectFolder)) ?? {};
  const newConfig = {
    ...currentConfig,
    ...config,
  };

  await writeJson(getAstroAppConfigPath(projectFolder), newConfig);
}
